/**
 * Generates a Tailwind CSS color class with optional opacity
 * @param color - Color name (e.g., 'red-500') or hex value (e.g., '#ff0000')
 * @param opacity - Optional opacity value (e.g., '50' for 50% opacity)
 * @returns Tailwind CSS class string (e.g., 'red-500/50' or '[#ff0000]/20')
 */
export function twColorClass(color: string, opacity?: string): string {
    const isHexColor = color.startsWith('#');
    const colorValue = isHexColor ? `[${color}]` : color;
    const shouldAddOpacity = opacity && opacity !== '100';
    const opacityValue = shouldAddOpacity ? `/${opacity}` : '';

    return `${colorValue}${opacityValue}`;
}
